module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "بعد-ساعتين"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("بعد ساعَتين")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("انتَهت المُباراة بتتويج فريق العُروبة ببطولة أوّل دوريٍّ في الإمارات.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("وقع نظره على هاشم بين جماهير العُروبة وأرسل له ابتسامةً من مكانه، حاول \"سيف\" الوُصول إليه وقبل أن يقترب منه أمسكَت \"عفراء\" بيد \"سيف\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ظلّ هاشم واقفًا في مكانه يُراقب ردَّة فعل \"سيف\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سحب \"سيف\" يده، ثمَّ توجَّه نحو \"ميثة\" وأمسك يدها بعد أن ابتسم لها ومضى إلى هاشم، وعفراء تنظر إليهما.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عانقه سيف مرحّبًا وهمس في أذنه:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- انتهى كلُّ شيءٍ إذًا!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردّ هاشم: نعم، انتهى كلُّ شيء.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("عندما فرَغَا من السّلام والتّرحيب، ذكّره هاشم بالوعد الَّذي بينهما:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لقد وعدتني بأنَّك ستأتي معي إلى بغداد لعند أمّك عندما ينتهي كلُّ شيءٍ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("اكتفى سيف بابتسامةٍ، ثمَّ التفتَ إلى \"ميثة\" وقال:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- نادي الأولادَ ليُسلِّموا على ابن خالي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("مضت \"ميثة\" إلى حيثُ الأولاد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("سألَه هاشم وهو ينظرُ إلى عفراء:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أهذه عفراء إذًا؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حاول سيف ألّا ينظر إليها:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- نعم، هي، المُقيمة في ذاكرتي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لم أفهم!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- تركتني في عزّ احتياجي لها وسافَرت بحجّة الدّراسة منذُ أربعِ سنواتٍ، رحلَت بجسدها لكنّ حبّها ظلَّ هنا، \"أشار إلى ناحية قلبه وأكمل قائلًا: \"وفي خيالي\".")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أبقِها إذًا في خيالك لتستطيعَ العيش بسلامٍ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- صدِّقني لم يعُد لها وجودٌ في واقعي بعد الآن.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أتمنّى ذلك حقًّا، لكنّها رجعت وهي هنا الآن! وأنتَ تعرف بأنَّها هنا من أجلك!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لم تعدْ تَعني لي شيئًا، هي حتّى لا تشبه حبيبتي عفراء الَّتي تعرَّفت عليها قبل سنوات.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كيف لا تُشبهها؟ اشرح لي، لأنّني لم أفهم!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردّ مبتسمًا: هذا أفضل.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- المهمّ الآن كيف معنويّاتك للعودة إلى بغداد؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- تقصدُ لزيارة بغداد.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لكنَّك وعدتني!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- سأوفي بوعدي وأزور أمّي، لكنّني لا أفكّر بالاستقرار هناك.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لم يكن هذا رأيكَ قبل أربع سنواتٍ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وقتها كنتُ أريد الابتعاد عن كلِّ شيءٍ يذكّرني بها.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- والآن!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا يهمُّ إن كانت هنا أو في لندن؛ فوجودُها لم يعد مؤثّرًا في حياتي، لقد تعايَشْتُ مع غيابها، وأيضًا لا تستحقُّ أن أترك بلدي من أجلها خاصّةً في هذا الوقت!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a49197e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch006.vue
// module id = 75
// module chunks = 0